import { render, staticRenderFns } from "./LessonPlans.vue?vue&type=template&id=618b6054&scoped=true"
import script from "./LessonPlans.vue?vue&type=script&lang=js"
export * from "./LessonPlans.vue?vue&type=script&lang=js"
import style0 from "./LessonPlans.vue?vue&type=style&index=0&id=618b6054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618b6054",
  null
  
)

export default component.exports